import React from 'react'
import { Route, Switch } from 'react-router'
import { InternalReportsList } from './List'
import { InternalReportView } from './View'

export const InternalReportsRouter = () => (
  <Switch>
    <Route exact path='/internal-reports' component={InternalReportsList} />
    <Route exact path='/internal-reports/:slug' component={InternalReportView} />
  </Switch>
)
